import PropTypes from 'prop-types'
import DefaultIcon, { propTypes, defaultProps } from '../icons/Icon'

/**
 * Create a React Icon component
 *
 * @param {import('./interfaces').DefaultIconProps} props
 */
function Icon ({ iconProps, ...props }) {
  return DefaultIcon(iconProps ? Object.assign(props, iconProps) : props)
}

Icon.propTypes = Object.assign(
  { iconProps: PropTypes.shape(propTypes) },
  propTypes
)

Icon.defaultProps = Object.assign(defaultProps)

Icon.displayName = 'Icon'

const iconProps = PropTypes.shape(
  Object.assign({}, propTypes, { name: PropTypes.string })
)

export { Icon as default, iconProps, Icon }
